var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isFilter
      ? _c("div", [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "q-mb-md" },
                [
                  _c(
                    "q-btn",
                    {
                      staticClass: "no-shadow",
                      attrs: {
                        icon: "add",
                        size: "sm",
                        flat: "",
                        color: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.newFormModalOpen = !_vm.newFormModalOpen
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          Add New " +
                          _vm._s(_vm._f("singular")(_vm.column.label)) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c("q-btn", {
                    staticClass: "no-shadow inline-flex",
                    attrs: {
                      color: _vm.inputBgColor,
                      "text-color": "primary",
                      rounded: "",
                      icon: _vm.showOptions
                        ? "keyboard arrow up"
                        : "keyboard arrow down",
                      loading: _vm.loading
                    },
                    on: { click: _vm.handleBrowseData }
                  }),
                  _vm.loaded
                    ? _c(
                        "q-search",
                        {
                          staticClass: "no-shadow inline-flex on-right",
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            placeholder: "",
                            "hide-underline": "",
                            color: _vm.inputBgColor,
                            "inverted-light": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.term,
                            callback: function($$v) {
                              _vm.term = $$v
                            },
                            expression: "term"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: {
                              minCharacters: 1,
                              "max-results": 25,
                              "max-height": "400px"
                            },
                            on: { selected: _vm.selected, search: _vm.search }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "q-pa-md q-ma-sm bg-grey-1 full-width scroll",
                  staticStyle: { "max-height": "200px" }
                },
                _vm._l(_vm.value, function(item, index) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "row inline group" },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "q-pa-xs",
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            closable: "",
                            square: "",
                            dense: "",
                            color: _vm.inputBgColor,
                            "text-color": "primary",
                            icon: "more_vert"
                          },
                          on: {
                            hide: function($event) {
                              return _vm.handleRemove(index)
                            },
                            click: function($event) {
                              return _vm.handleClick(index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("relationLabel")(
                                  item,
                                  _vm.column,
                                  _vm.labelField
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _c("q-slide-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showOptions && _vm.options.length,
                        expression: "showOptions && options.length"
                      }
                    ]
                  },
                  [
                    _vm.showOptions && _vm.options.length >= 1
                      ? _c(
                          "q-list",
                          {
                            staticClass: "flat-box q-mt-md",
                            attrs: { striped: "", multiline: "" }
                          },
                          _vm._l(_vm.options, function(option) {
                            return _c(
                              "q-item",
                              {
                                key: option.id,
                                attrs: { link: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.selected(option, false)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      { attrs: { label: "" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("relationLabel")(
                                                option,
                                                _vm.column,
                                                _vm.column.relation.label
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm.column.relation.subtitle
                                      ? _c(
                                          "q-item-tile",
                                          { attrs: { sublabel: "" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm._f("relationLabel")(
                                                    option,
                                                    _vm.column,
                                                    _vm.column.relation.subtitle
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "row q-mt-md" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("q-pagination", {
                            staticClass: "text-center justify-center",
                            attrs: {
                              value: _vm.pagination.page,
                              color: "secondary",
                              min: 1,
                              max: _vm.maxPage,
                              "max-pages": 15,
                              "boundary-numbers": "",
                              "boundary-links": ""
                            },
                            on: { change: _vm.handlePageChange }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm.addButton && _vm.template === "form"
                ? _c("div", [
                    _vm.newFormModalOpen
                      ? _c(
                          "div",
                          [
                            _c(
                              "q-modal",
                              {
                                attrs: {
                                  "content-classes": "q-pa-lg",
                                  "content-css":
                                    "min-width: 70vw; max-width: 95vw",
                                  "no-backdrop-dismiss": "",
                                  "no-esc-dismiss": ""
                                },
                                model: {
                                  value: _vm.newFormModalOpen,
                                  callback: function($$v) {
                                    _vm.newFormModalOpen = $$v
                                  },
                                  expression: "newFormModalOpen"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "fit" },
                                  [
                                    _c("q-btn", {
                                      staticStyle: {
                                        top: "0",
                                        right: "0",
                                        position: "relative",
                                        float: "right"
                                      },
                                      attrs: { flat: "", icon: "close" },
                                      on: {
                                        click: function($event) {
                                          _vm.newFormModalOpen = false
                                        }
                                      }
                                    }),
                                    _vm.newFormModalOpen
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "q-display-1 text-secondary capitalize no-margin"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Add New " +
                                                    _vm._s(
                                                      _vm._f("singular")(
                                                        _vm.column.label
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm.relationResource
                                              ? _c(
                                                  "base-form",
                                                  {
                                                    attrs: {
                                                      resource:
                                                        _vm.relationResource,
                                                      "parent-resource":
                                                        _vm.parentResource,
                                                      "parent-resource-column":
                                                        _vm.column,
                                                      "is-modal": true
                                                    },
                                                    on: { add: _vm.handleNew }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "full-width q-mt-md q-pb-lg",
                                                        attrs: {
                                                          slot: "goback"
                                                        },
                                                        slot: "goback"
                                                      },
                                                      [
                                                        _c("q-btn", {
                                                          attrs: {
                                                            icon: "close",
                                                            label:
                                                              "Cancel / Close",
                                                            color: "grey-6",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.newFormModalOpen = false
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }